import { langFallback$Fetch } from '../../lang/utils/langfetch'
import { csrfTokenService } from '../csrf/CsrfTokenService'
import { SearchFilters } from '../search/schemas'
import { AllocationAlertPayloadCampsiteDetails } from './types'

export class AllocationAlertRepositoryFetch {
  async subscribeToCampsiteDetails(
    payload: AllocationAlertPayloadCampsiteDetails,
  ): Promise<void> {
    const { csrfToken } = await csrfTokenService()
    await langFallback$Fetch(
      payload.langCode,
      '/allocation_alerts/form/?no_success_url=1',
      {
        method: 'POST',
        headers: {
          'X-CSRFToken': csrfToken,
        },
        body: this.getFormData(payload),
        redirect: 'manual',
      },
    )
  }

  private getFormData(payload: AllocationAlertPayloadCampsiteDetails) {
    const { pitchtypesIds, ...params } = payload
    const postData = new FormData()
    pitchtypesIds.forEach((id) => postData.append('pitchtypes', id))
    for (const key of Object.keys(params)) {
      postData.append(key, params[key])
    }
    return postData
  }

  async subscribeToSearchResults(
    email: string,
    searchFilters: SearchFilters,
    langCode: string,
  ) {
    const { csrfToken } = await csrfTokenService()
    await langFallback$Fetch(langCode, '/allocation-alerts-location/create/', {
      method: 'POST',
      headers: {
        'X-CSRFToken': csrfToken,
      },
      body: this.getSearchResultsFormData(email, searchFilters),
    })
  }

  private getSearchResultsFormData(
    email: string,
    searchFilters: SearchFilters,
  ) {
    const postData = new FormData()
    postData.append('email', email)
    if (searchFilters.dates) {
      postData.append('arrive', searchFilters.dates.arrive)
      postData.append('depart', searchFilters.dates.depart)
    }
    if (searchFilters.party) {
      postData.append('adults', searchFilters.party.adults.toString())
      postData.append('child_ages', searchFilters.party.childAges.toString())
      if (searchFilters.party.dogs) {
        postData.append('dogs', searchFilters.party.dogs.toString())
      }
    }
    const within = searchFilters.within || searchFilters.area?.rangeMiles
    if (within) {
      postData.append('within', within.toString())
    }
    if (searchFilters.hierarchyPath) {
      postData.append('hierarchy_path', searchFilters.hierarchyPath)
    }
    for (const id of searchFilters.categoryIds || []) {
      postData.append('category_ids', id)
    }
    for (const facet of searchFilters.facets || []) {
      postData.append('facets', facet)
    }
    if (searchFilters.area && !searchFilters.area.isEmptyPoint) {
      postData.append('place_lat', searchFilters.area.lat.toString())
      postData.append('place_lng', searchFilters.area.lng.toString())
    }
    if (searchFilters.placename && !searchFilters.hierarchyPath) {
      postData.append('place_name', searchFilters.placename)
      postData.append('place_name_short', searchFilters.placename)
    }
    if (searchFilters.bounds) {
      postData.append('bounds', JSON.stringify(searchFilters.bounds))
    }
    return postData
  }
}
